import { AlertTriangle, CheckCircle2, Info, X, XCircle } from "lucide-react";
import { useToasts } from "@/lib/toast";
import { cn } from "@/lib/format";

const ICON = { info: Info, success: CheckCircle2, warning: AlertTriangle, error: XCircle } as const;
const TONE = {
  info: "border-sky-300 dark:border-sky-800",
  success: "border-green-300 dark:border-green-800",
  warning: "border-amber-300 dark:border-amber-700",
  error: "border-red-400 dark:border-red-800",
} as const;
const ICON_TONE = { info: "text-sky-600", success: "text-green-600", warning: "text-amber-500", error: "text-red-600" } as const;

export function Toaster() {
  const { toasts, dismiss } = useToasts();
  return (
    <div className="pointer-events-none fixed right-4 bottom-4 z-50 flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2" aria-live="polite">
      {toasts.map((t) => {
        const Icon = ICON[t.tone];
        return (
          <div key={t.id} role={t.tone === "error" ? "alert" : "status"} className={cn("pointer-events-auto flex gap-3 rounded-lg border bg-surface p-3 shadow-lg", TONE[t.tone])}>
            <Icon className={cn("mt-0.5 size-5 shrink-0", ICON_TONE[t.tone])} aria-hidden />
            <div className="min-w-0 flex-1 text-sm">
              <p className="font-semibold">{t.title}</p>
              {t.message && <p className="text-muted">{t.message}</p>}
              {t.detail && <p className="mt-1 font-mono text-[11px] text-subtle">{t.detail}</p>}
            </div>
            <button type="button" className="self-start rounded p-0.5 text-subtle hover:bg-surface-2" onClick={() => dismiss(t.id)} aria-label="Dismiss">
              <X className="size-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
